import { useEffect } from 'react'

interface MetaTagsProps {
  title?: string
  description?: string
  image?: string
  url?: string
}

const DEFAULT_TITLE = 'Hudson My Home | Private Home Management | Des Moines, Iowa'
const DEFAULT_DESCRIPTION =
  'We maintain your home so you don\'t have to. Hudson My Home provides proactive home management, a dedicated home professional, and year-round care for homeowners in the Des Moines metro.'
const DEFAULT_IMAGE =
  'https://nuykijziltpoqaszbrwi.supabase.co/storage/v1/object/public/site-images/HMH_Primary_Logo_White.png'
const DEFAULT_URL = 'https://hudsonmyhome.com'

function setMetaTag(attr: string, key: string, content: string) {
  let el = document.querySelector(`meta[${attr}="${key}"]`) as HTMLMetaElement | null
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attr, key)
    document.head.appendChild(el)
  }
  el.setAttribute('content', content)
}

export const MetaTags: React.FC<MetaTagsProps> = ({
  title = DEFAULT_TITLE,
  description = DEFAULT_DESCRIPTION,
  image = DEFAULT_IMAGE,
  url = DEFAULT_URL,
}) => {
  useEffect(() => {
    document.title = title

    setMetaTag('name', 'description', description)
    setMetaTag('name', 'author', 'Hudson My Home')

    setMetaTag('property', 'og:type', 'website')
    setMetaTag('property', 'og:title', title)
    setMetaTag('property', 'og:description', description)
    setMetaTag('property', 'og:image', image)
    setMetaTag('property', 'og:url', url)
    setMetaTag('property', 'og:site_name', 'Hudson My Home')

    setMetaTag('name', 'twitter:card', 'summary_large_image')
    setMetaTag('name', 'twitter:title', title)
    setMetaTag('name', 'twitter:description', description)
    setMetaTag('name', 'twitter:image', image)
  }, [title, description, image, url])

  return null
}

export default MetaTags
